import Styles from './EmptyPreview.module.scss'
import { ReactComponent as EmptyDocIcon } from './emptyDoc.svg'
import cx from 'classnames'

interface Props {
  className?: string
}

export const EmptyDoc = ({ className }: Props) => (
  <div className={cx(Styles.empty, className)}>
    <EmptyDocIcon />
    <div className={Styles.emptyText}>This doc is empty</div>
  </div>
)
